import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {UserLoginService} from '../services/user-login.service';


export const LoginAdminGuard: CanActivateFn = () => {
    const userLoginService = inject(UserLoginService);
    const router = inject(Router);


    if (!window.location.hostname.includes(environment.administratorDomain) && window.location.hostname !== 'localhost') {
        return false;
    }

    if (userLoginService.getIsAdminLoggedIn()) {
        router.navigate([environment.baseAdminPath + '/client']).then();
        return false;
    }
    return true;
};
